import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import useTailwindBreakpoint from "../hooks/useTailwindBreakpoint";
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faPlus } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";

const LeftMenu = ({ menu }) => {
  const location = useLocation();
  const authUser = useSelector((state) => state.auth);
  const currentBp = useTailwindBreakpoint();
  const [viewMenu, setViewMenu] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    setViewMenu(["sm", "md", "lg"].includes(currentBp) ? false : true);
  }, [currentBp]);

  return (
    <>
      <div className={`rounded-xl shadow`}>
        {["sm", "md", "lg"].includes(currentBp) && (
          <div
            className={`p-4 bg-bioport-blue border-bioport-orange text-white px-6 ${
              viewMenu ? "rounded-t-lg border-b-4 " : "rounded-lg"
            }  shadow justify-between flex ${viewMenu && "border-b pb-4"}`}
          >
            <div>Menu</div>
            <div>
              <FontAwesomeIcon
                icon={viewMenu ? faPlus : faBars}
                onClick={() => setViewMenu(!viewMenu)}
                className={`${
                  viewMenu && "rotate-45"
                } text-lg transform transition-all font-bold cursor-pointer`}
              />
            </div>
          </div>
        )}
        <div className={`${!viewMenu ? "hidden" : ""} text-sm xl:text-md`}>
          {menu &&
            Object.values(menu)
              .filter((m) => m.permissions.includes(authUser.user.roles[0]))
              .map((s, key) => (
                <Link to={s.link} key={key}>
                  <div
                    className={`
                    ${
                      location.pathname.startsWith(s.link) && s.link !== "/"
                        ? "bg-bioport-blue text-white"
                        : "bg-gray-50 hover:bg-white hover:text-bioport-orange-dark lg:hover:pl-8"
                    }
                    ${key === 0 && "border-t lg:rounded-t-lg"} ${
                      key === Object.values(menu).length - 1 && "rounded-b-lg"
                    }
                    border-gray-300 border-b transition-all duration-400 border-l border-r px-6 cursor-pointer h-12 lg:h-16 flex items-center`}
                  >
                    <span className="hidden lg:block">{s.icon && s.icon}</span>{" "}
                    {t(s.label)}
                  </div>
                </Link>
              ))}
        </div>{" "}
      </div>
    </>
  );
};

export default LeftMenu;
